/* eslint-disable max-lines */
import React, { useContext, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import ClinicInput from '../UI/inputs/ClinicInput';
import CalendarInput from '../UI/inputs/CalendarInput';
import AutosizeTextarea from '../UI/inputs/AutosizeTextarea';
import { MainSelect, SearchableSelect, TimeSelect } from '../UI';
import { makeStyles } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import { getGenericList } from '../../redux/General/GeneralAction';
import {
    changeStateOfAppointment,
    createAppointment,
    getAppointmentDetail,
    editAppointment,
    resetAppointmentEditRelatedStates
} from '../../redux/Appointment/AppointmentAction';
import { getPatient } from '../../redux/Patient/PatientAction';

import moment from 'moment-timezone';
import { SubmitButton } from '../UI';
import { phone } from '../../utils/validationRegex';
import MessagesContext from '../../contexts/messagesContext';
import LanguageContext from '../../contexts/languageContext';
import { getClinicStartTime, getClinicTimeZone } from '../../utils/storage';
const styles = makeStyles({
    formContainer: {
        maxWidth: '545px',
        margin: '0 auto'
    },
    submitBtnContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: '20px',
        position: 'sticky',
        bottom: '0'
    },
    datePickerContainer: {
        marginInlineEnd: '15px',
        width: '180px'
    }
});
function AdmissionForm(props) {
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);
    const classes = styles();
    const { getGenericList, getPatient } = props;
    useEffect(() => {
        if (
            props?.appointment &&
            props?.appointment?.patient?.id &&
            (props?.patient?.id !== props?.appointment?.patient?.id || !props.patient)
        ) {
            getPatient(props?.appointment?.patient.id);
        }
    }, [props.patient, props?.appointment, getPatient]);
    useEffect(() => {
        if (!props.cities || !props.cities?.length) {
            getGenericList('city');
        }
    }, [props.cities, getGenericList]);
    useEffect(() => {
        if (!props.arrivalModes || !props.arrivalModes?.length) {
            getGenericList('arrival_mode');
        }
    }, [props.arrivalModes, getGenericList]);
    useEffect(() => {
        if (!props.insuranceTypes || !props.insuranceTypes?.length) {
            getGenericList('insurance_type');
        }
    }, [props.insuranceTypes, getGenericList]);
    const initiateValues = () => {
        const { patient, selectedAdmission } = props;
        if (selectedAdmission) {
            return {
                phoneNumber1: selectedAdmission.phone_number_1 || '',
                phoneNumber2: selectedAdmission.phone_number_2 || '',
                insurance: {
                    insuranceNumber: selectedAdmission.insurance_number || '',
                    insuranceType: selectedAdmission.insurance_type?.id || ''
                },
                arrivalMode: selectedAdmission.arrival_mode?.id || '',
                patientCity: selectedAdmission.city?.id || '',
                street: selectedAdmission.street || '',
                admitted: moment(selectedAdmission.admitted).format('YYYY-MM-DD'),
                admittedTime: moment(selectedAdmission.admitted).format('HH:MM'),
                companionFirstName: selectedAdmission.companion_first_name || '',
                companionLastName: selectedAdmission.companion_last_name || '',
                companionRelation: selectedAdmission.companion_relation || ''
            };
        } else {
            return {
                phoneNumber1: patient?.phone_number_1 || '',
                phoneNumber2: patient?.phone_number_2 || '',
                insurance: {
                    insuranceNumber: '',
                    insuranceType: ''
                },
                arrivalMode:
                    props.arrivalModes && props.arrivalModes.find((val) => val.title === 'شخصی')
                        ? props.arrivalModes.find((val) => val.title === 'شخصی').id
                        : '',
                patientCity: patient?.city || '',
                street: patient?.street || '',
                admitted: props.selectedDate,
                admittedTime: new Date().getHours() + ':' + new Date().getMinutes(),
                companionFirstName: '',
                companionLastName: '',
                companionRelation: ''
            };
        }
    };
    const createAdmissionParam = (values) => {
        return {
            admitted:
                values.admittedTime && values.admitted
                    ? moment(values.admitted + ' ' + values.admittedTime).format()
                    : null,
            type: 'clinical',
            insurance_number: values.insurance?.insuranceNumber
                ? values.insurance?.insuranceNumber
                : null,
            insurance_type: values.insurance?.insuranceType
                ? values.insurance?.insuranceType
                : null,
            dismiss_date: null,
            is_dismissed: null,
            arrival_mode: values.arrivalMode ? values.arrivalMode : null,
            patient: props.patient
                ? props.patient.id
                : props.match?.params?.id
                ? +props.match?.params?.id
                : +props.selectedAppointment?.patient?.id,
            phone_number_1: values.phoneNumber1 ? values.phoneNumber1.trim() : null,
            phone_number_2: values.phoneNumber2 ? values.phoneNumber2.trim() : null,
            city: values.patientCity ? values.patientCity : null,
            street: values.street ? values.street.trim() : null,
            companion_first_name: values.companionFirstName
                ? values.companionFirstName.trim()
                : null,
            companion_last_name: values.companionLastName ? values.companionLastName.trim() : null,
            companion_relation: values.companionRelation ? values.companionRelation.trim() : null
        };
    };
    const setAppointmentTime = (values) => {
        const clinicStartTime = getClinicStartTime();
        const timezone = getClinicTimeZone();
        const time = values.admittedTime
            ? moment(values.admitted + ' ' + values.admittedTime)
                  .tz(timezone)
                  .format()
            : moment(values.admitted + ' ' + clinicStartTime)
                  .tz(timezone)
                  .format();
        return time;
    };
    const getSubmitButtonText = () => {
        if (props.selectedAdmission && props.synchronousAdmission) {
            return messages.editAppointmentSynchAdmit;
        } else if (props.synchronousAdmission) {
            return messages.submitAppointmentSynchAdmit;
        } else {
            return messages.submitAdmission;
        }
    };
    return (
        <Formik
            enableReinitialize
            initialValues={initiateValues()}
            validationSchema={Yup.object({
                phoneNumber1: Yup.string().matches(phone, messages.validations.incorrectValue),
                phoneNumber2: Yup.string().matches(phone, messages.validations.incorrectValue),

                admitted:
                    !props.appointment?.admitted || !props.selectedAppointment?.admitted
                        ? Yup.date().required()
                        : Yup.date().nullable(),
                admittedTime: Yup.string().when('admitted', {
                    is: (value) => value,
                    then: Yup.string().required(messages.validations.required),
                    otherwise: Yup.string().notRequired().nullable()
                }),
                insurance: Yup.object().shape(
                    {
                        insuranceNumber: Yup.string().when('insuranceType', {
                            is: (value) => value !== null && value !== undefined,
                            then: Yup.string()
                                .required(messages.validations.required)
                                .min(5, messages.validations.incorrectValue)
                                .max(32, messages.validations.incorrectValue),
                            otherwise: Yup.string()
                                .notRequired()
                                .nullable()
                                .min(5, messages.validations.incorrectValue)
                                .max(32, messages.validations.incorrectValue)
                        }),
                        insuranceType: Yup.string().when('insuranceNumber', {
                            is: (value) => value !== null && value !== undefined,
                            then: Yup.string().required(messages.validations.required),
                            otherwise: Yup.string().notRequired().nullable()
                        })
                    },
                    ['insuranceNumber', 'insuranceType']
                ),
                patientCity: Yup.number().when('street', {
                    is: (value) => value,
                    then: Yup.number().required(messages.validations.required),
                    otherwise: Yup.number().notRequired().nullable()
                })
            })}
            onSubmit={async (values, { setSubmitting }) => {
                let createResponse;
                if (props.synchronousAdmission) {
                    let params = props.editedAppointment || props.selectedAppointment;
                    if (props.requiredTime) {
                        params = { ...params, appointed: setAppointmentTime(values) };
                    }
                    if (params?.id) {
                        createResponse = await props.editAppointment(params.id, params);
                    } else {
                        createResponse = await props.createAppointment(params);
                    }
                    if (!createResponse || +createResponse.status !== 200) {
                        return;
                    }
                }
                const admission = createAdmissionParam(values);
                const response = await props.changeStateOfAppointment(
                    props.synchronousAdmission
                        ? createResponse.data?.id
                        : props.editedAppointment?.id || props.selectedAppointment?.id,
                    props.destinationState,
                    'last',
                    admission
                );
                setSubmitting(false);
                if (response?.status === 200) {
                    // props.handleStateChange(response?.data);

                    props.resetAppointmentEditRelatedStates(null);

                    props.closeModal();
                }
            }}
        >
            {({ values, errors, touched, setFieldValue, isSubmitting }) => (
                <Form className={classes.formContainer}>
                    {props.title && <h2>{props.title}</h2>}
                    <div>
                        <div className="form-row">
                            <div className={classes.datePickerContainer}>
                                <CalendarInput
                                    width="100%"
                                    label={messages.date}
                                    name="admitted"
                                    type="text"
                                    value={values.admitted ? values.admitted : undefined}
                                    errors={errors.admitted && touched.admitted}
                                    setValue={(value) => setFieldValue('admitted', value)}
                                />
                            </div>
                            <TimeSelect
                                value={values.admittedTime}
                                setTime={(time) => setFieldValue('admittedTime', time)}
                                label={messages.time}
                                errors={errors.admittedTime && touched.admitted}
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <ClinicInput name="phoneNumber1" label={messages.phoneNo} type="text" />
                    </div>
                    <hr className="form-divider" />
                    <div className="form-row">
                        <SearchableSelect
                            options={lang === 'fa' ? props.insuranceTypes : []}
                            optionsLabel="title"
                            width={256}
                            label={messages.insurance}
                            name="insurance.insuranceType"
                            value={values.insurance.insuranceType}
                            errors={errors.insurance?.insuranceType}
                            setValue={(value) =>
                                setFieldValue('insurance.insuranceType', value, false)
                            }
                        />
                        <ClinicInput
                            name="insurance.insuranceNumber"
                            label={messages.insuranceNo}
                            type="text"
                        />
                    </div>

                    <div className="form-row">
                        <ClinicInput name="phoneNumber2" label={messages.phoneNo} type="text" />
                    </div>
                    {lang === 'fa' && (
                        <div className="form-row">
                            <SearchableSelect
                                options={props.cities}
                                optionsLabel="title"
                                label={messages.city}
                                name="patientCity"
                                value={values.patientCity}
                                errors={errors.patientCity}
                                setValue={(value) => setFieldValue('patientCity', value, false)}
                            />
                        </div>
                    )}
                    <div className="form-row">
                        <AutosizeTextarea
                            name="street"
                            label={messages.address}
                            width={400}
                            rows={3}
                        />
                    </div>
                    <hr className="form-divider" />
                    <div className="form-row">
                        <MainSelect
                            name="arrivalMode"
                            label={messages.arrivalMode}
                            width={200}
                            options={props.arrivalModes}
                            valuePropName="id"
                            labelPropName={lang === 'fa' ? 'title' : 'en_title'}
                        />
                    </div>

                    <div className="form-row">
                        <ClinicInput
                            name="companionFirstName"
                            label={messages.patientCompanionName}
                            type="text"
                        />
                        <ClinicInput
                            name="companionLastName"
                            label={messages.patientCompanionLastName}
                            type="text"
                        />
                        <ClinicInput
                            name="companionRelation"
                            label={messages.companionRelationship}
                            type="text"
                        />
                    </div>

                    <div className={classes.submitBtnContainer}>
                        {props.synchronousAdmission && (
                            <SubmitButton
                                secondary={true}
                                submitText={messages.prev}
                                handleClick={() => props.handleGoBack()}
                            />
                        )}
                        <SubmitButton
                            isSubmitting={isSubmitting}
                            submitText={getSubmitButtonText()}
                        />
                    </div>
                </Form>
            )}
        </Formik>
    );
}
AdmissionForm.propTypes = {
    classes: PropTypes.object,
    match: PropTypes.object,
    admissionTypes: PropTypes.array,
    arrivalModes: PropTypes.array,
    cities: PropTypes.array,
    insuranceTypes: PropTypes.array,
    getGenericList: PropTypes.func,
    changeStateOfAppointment: PropTypes.func,
    setFieldValue: PropTypes.func,
    appointment: PropTypes.object,
    // handleStateChange: PropTypes.func,
    handleError: PropTypes.func,
    destinationState: PropTypes.oneOf(['admitted', 'appointed', 'entered', 'exited']),
    synchronousAdmission: PropTypes.any,
    createAppointment: PropTypes.func,
    requiredTime: PropTypes.any,
    selectedDate: PropTypes.string,
    getPatient: PropTypes.func,
    patient: PropTypes.object,
    handleGoBack: PropTypes.func,
    title: PropTypes.string,
    closeModal: PropTypes.func,
    selectedAppointment: PropTypes.object,
    editedAppointment: PropTypes.object,
    editAppointment: PropTypes.func,
    selectedAdmission: PropTypes.object,
    resetAppointmentEditRelatedStates: PropTypes.func
};
const mapStateToProps = (state) => {
    return {
        arrivalModes: state.general.generics.arrivalModes,
        cities: state.general.generics.cities,
        insuranceTypes: state.general.generics.insuranceTypes,
        selectedDate: state.appointment?.date?.selected,
        patient: state.patient.patient.profile,
        selectedAppointment: state.appointment.selectedAppointment,
        editedAppointment: state.appointment.editedAppointment,
        selectedAdmission: state.appointment.selectedAdmission
    };
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getGenericList,
            changeStateOfAppointment,
            createAppointment,
            getPatient,
            getAppointmentDetail,
            editAppointment,
            resetAppointmentEditRelatedStates
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(AdmissionForm);
